/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, useEffect, useState } from 'react'
import { Routes, Route, BrowserRouter, Navigate, useLocation } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth, setAuth, getAuth } from '../modules/auth'
import { App } from '../App'
import DocumentViewerWrapper from '../pages/company/components/DocumentsViewGenericWrapper'
import CheckJwtInvestmentModelling from '../pages/company/components/CheckJwtInvestmentModelling'
import { useRefetchAccessToken, useUserContextQuery } from '../modules/auth/core/_requests'
import jwtDecode, { JwtPayload } from 'jwt-decode'
import * as authHelper from '../modules/auth/core/AuthHelpers'
import { setUserInvestors, setUserProjects, setUserRoles } from '../../utils/SessionStorageUtils'
import { useAuthorizationStore } from '../../store/useAuthStore'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  let { role } = useAuth()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='documentViewer/:IframeToken' element={<DocumentViewerWrapper />} />
          <Route
            path='publicInvestmentModelling/:token'
            element={<CheckJwtInvestmentModelling />}
          />
          {role  ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              {/*<Route index element={<Navigate to='/dashboard' />} /> */}
            </>
          ) : (
            <>
              {/* <Route path='auth/*' element={<AuthPage />} /> */}
              <Route path='*' element={<AuthPage />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
